<template>
  <div class="flex flex-col gap-4">
    <TranscriptionUpsellingInline v-if="showAiAddonUpsellingInline" @close="closeAIAddon" />
    <template v-if="isTranscriptionGenerated && !isEditProcessing">
      <template v-if="isTranscriptionFinished">
        <TranscriptionEmpty v-if="isTranscriptionEmpty" />
        <TranscriptionWrapper v-else />
      </template>
      <TranscriptionProcessing v-else-if="isTranscriptionProcessing" />
      <TranscriptionRetry v-else-if="isTranscriptionFailed" />
    </template>

    <TranscriptionVideoProcessing v-else-if="isEditProcessing" />
    <TranscriptionRequest v-else-if="(isTranscriptionEnabled || hasAiAddon) && isCurrentItemOwner" />
    <TranscriptionUpselling v-else-if="isCurrentItemOwner" />
  </div>
</template>

<script lang="ts" setup>
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { storeToRefs } from 'pinia';
import { computed, onBeforeMount, ref } from 'vue';

import TranscriptionRequest from './TranscriptionRequest.vue';
import TranscriptionEmpty from './TranscriptionEmpty.vue';
import TranscriptionUpselling from './TranscriptionUpselling.vue';
import TranscriptionWrapper from './general/TranscriptionWrapper.vue';
import TranscriptionRetry from './TranscriptionRetry.vue';
import TranscriptionProcessing from './TranscriptionProcessing.vue';
import TranscriptionVideoProcessing from './TranscriptionVideoProcessing.vue';
import TranscriptionUpsellingInline from './TranscriptionUpsellingInline.vue';

import { useAddon } from '@/modules/viewer/composables/useAddon';
import { useFeatures } from '@/composables/useFeatures';
import { useUser } from '@/modules/viewer/composables/useUser';

const transcriptionStore = useTranscriptionStore();
const store = useViewerItemStore();

const { isCurrentItemOwner } = useUser();
const { getFeature } = useFeatures();
const { hasAiAddon } = useAddon();

const { isEditProcessing } = storeToRefs(store);
const { isTranscriptionEmpty, isTranscriptionGenerated, isTranscriptionFinished, isTranscriptionFailed, isTranscriptionProcessing } =
  storeToRefs(transcriptionStore);

const isTranscriptionEnabled = getFeature('viewer-transcription');

const showAiAddon = ref(true);

const closeAIAddon = () => {
  showAiAddon.value = false;
};
const showAiAddonUpsellingInline = computed(() => {
  return isTranscriptionEnabled.value && isCurrentItemOwner.value && !hasAiAddon.value && showAiAddon.value;
});

onBeforeMount(() => transcriptionStore.loadTranscription(transcriptionStore.transcriptionId));
</script>
